import {getAll} from '../../../../services/common_requests'

const OPTION_PAGE_SIZE = 100
const OPTION_MAX_PAGES = 50

export async function fetchAllOptions(endpoint: string): Promise<any[]> {
  let page = 0
  const allItems = new Map<string, any>()

  while (page < OPTION_MAX_PAGES) {
    const response = await getAll({page, size: OPTION_PAGE_SIZE}, endpoint)
    const items = Array.isArray(response?.data) ? response.data : []

    if (!items.length) break

    const beforeCount = allItems.size
    items.forEach((item: any) => {
      const key = item?._id ? String(item._id) : ''
      if (key) allItems.set(key, item)
    })

    const totalPages = Number(response?.payload?.pagination?.totalPages || 0)
    if (totalPages > 0) {
      if (page + 1 >= totalPages) break
      page += 1
      continue
    }

    if (items.length < OPTION_PAGE_SIZE) break
    if (allItems.size === beforeCount) break
    page += 1
  }

  return Array.from(allItems.values())
}
